// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"301":"5d46452b","539":"39237d2e","928":"dbd50dd7"}[chunkId] + ".chunk.css";
};